import Loadable from "components/Loadable";
import ProjectBase from "pages/project/ProjectBase";
import {lazy} from "react";

const ProjectList = Loadable(lazy(() => import('pages/project/list')));
const ProjectCreate = Loadable(lazy(() => import('pages/project/create')));
const JobCalendar = Loadable(lazy(() => import('pages/project/job-calendar/JobCalendar')));
// const ProjectDetailsDashboard = Loadable(lazy(() => import('pages/project/job/dashboard/project-dashboard')));
const JobCard = Loadable(lazy(() => import('pages/project/job/job-card/job-card')));
const JobBase = Loadable(lazy(() => import('pages/project/job/project')));

const QuotationList = Loadable(lazy(() => import('pages/accounts/quotation/quotation-list')));
const AddQuotation = Loadable(lazy(() => import('pages/accounts/quotation/add-quotation')));
const ViewQuotation = Loadable(lazy(() => import('pages/accounts/quotation/view-quotation')));
const TaskBase = Loadable(lazy(() => import('pages/project/job/tasks/TaskBase')));
const ViewTask = Loadable(lazy(() => import('pages/project/job/tasks/view-task')));

const OrderMaterial = Loadable(lazy(() => import('pages/project/job/material/order-material')));
const ViewProjectFeedback = Loadable(lazy(() => import('pages/project/job/feedback/view-project-feedback')));
const ViewOrderMaterial = Loadable(lazy(() => import('pages/project/job/material/view-material')));
const ProjectQuotation = Loadable(lazy(() => import('pages/project/job/quotation/project-quotation')));
const PurchaseList = Loadable(lazy(() => import('pages/accounts/purchases/purchase')));
const AddPurchase = Loadable(lazy(() => import('pages/accounts/purchases/add-edit-purchase')));
const ViewPurchase = Loadable(lazy(() => import('pages/accounts/purchases/view-purchase')));
const ProjectPayment = Loadable(lazy(() => import('pages/project/job/payment/payment')));
const ProjectCustomer = Loadable(lazy(() => import('pages/project/job/customer')));
const ProjectFeedback = Loadable(lazy(() => import('pages/project/job/feedback/project-feedback')));
const PrepareNDSendQuotation = Loadable(lazy(() => import('pages/accounts/quotation/prepare-send-quotation')));
const Snagging = Loadable(lazy(() => import('pages/project/job/snagging/snagging')));
// const Payment = Loadable(lazy(() => import('pages/project/payments/payment')));
;
const MakeInvoice = Loadable(lazy(() => import('pages/accounts/quotation/make-invoice')));
const ProjectRoutes = {
    path: 'project',
    element: <ProjectBase />,
    children: [
        {
            path: 'job',
            // element: <ProjectList />,
            children: [
                {
                    path: '',
                    element: <ProjectList />
                },
                {
                    path: 'calendar',
                    element: <JobCalendar />
                },
                {
                    path: 'create',
                    element: <ProjectCreate />
                },
                {
                    path: ':project_id',
                    element: <JobBase />,
                    children:[
                        {
                            path: '',
                            element: <JobCard />
                        },
                        {
                            path: 'task',
                            children:[
                                {
                                    path: '',
                                    element: <TaskBase />
                                },
                                {
                                    path: ':taskID',
                                    element: <ViewTask/>
                                }
                            ]
                        },
                       
                       
                        {
                            path: 'order-material',
                            // element: <QuotationList />,
                            children:[
                                {
                                    path: '',
                                    element: <OrderMaterial />
                                },

                                {
                                    path: 'view/:id',
                                    element: <ViewOrderMaterial />
                                },

                            ],
                        } ,
                        {
                            path: 'quotation',
                            element: <ProjectQuotation />,

                        },
                        {
                            path: 'purchases',
                            // element: <QuotationList />,
                            children:[
                                {
                                    path: '',
                                    element: <PurchaseList />
                                },
                                {
                                    path: 'new-purchase',
                                    element: <AddPurchase />
                                },
                                {
                                    path: 'view-purchase/:id',
                                    element: <ViewPurchase />
                                },
                                {
                                    path: 'edit-purchase/:id',
                                    element: <AddPurchase />
                                },
                             
                        
                            ],
                        },
                        {
                            path: 'payment',
                            element: <ProjectPayment />
                        },
                        {
                            path: 'snagging',
                            element: <Snagging />
                        },
                        {
                            path: 'customer',
                            element: <ProjectCustomer />
                        },
                        {
                            path: 'feedback',
                            // element: <QuotationList />,
                            children:[
                                {
                                    path: '',
                                    element: <ProjectFeedback />
                                },

                                {
                                    path: 'view/:id',
                                    element: <ViewProjectFeedback />
                                },

                            ],
                        } ,
                    ]
                }
            ]},
        {
            path: 'quotation',
            // element: <QuotationList />,
            children:[
                {
                    path: '',
                    element: <QuotationList />
                },
                {
                    path: 'new-quotation',
                    element: <AddQuotation />
                },
                {
                    path: 'view-quotation/:id',
                    element: <ViewQuotation />
                },
                {
                    path: 'edit-quotation/:id',
                    element: <AddQuotation />
                },
                {
                    path: 'prepare-send/:id',
                    element: <PrepareNDSendQuotation />
                },
                {
                    path: 'make-invoice/:id',
                    element: <MakeInvoice />
                },
            ],
        },
       
  

    ]


}

export default ProjectRoutes;
